import React from "react";
import PropTypes from "prop-types";
import SelectLocation from "../dropdown";
import Dropdown from "react-dropdown";

const options1 = [
  { value: "op1", label: "Job Title" },
  { value: "op2", label: "Design & Creative" },
  { value: "op3", label: "Design" },
  { value: "op4", label: "Ux/Ui" },
];

const options2 = [
  { value: "op1", label: "Salary Estimate" },
  { value: "op2", label: "Salary Estimate 1" },
  { value: "op3", label: "Salary Estimate 2" },
];
const options3 = [
  { value: "op1", label: "Experience" },
  { value: "op2", label: "Experience 1" },
  { value: "op3", label: "Experience 2" },
];

function Form2({ getCompanyList, setSearchUserName, searchUserName }) {
  const handleSearch = (e) => {
    e.preventDefault();
    getCompanyList(1, searchUserName); // You can pass page 1 and the searchUserName to start a new search.
  };

  return (
    <section className="form-sticky stc2 mt-5 container">
      <div className="container">
        <div className="job-search-form st1 employers-form">
          <form onSubmit={handleSearch}>
            <div className="row-group-search inner-form">
              <div className="form-group-1 form-style-1">
                <input
                  type="email"
                  className="form-control p-2"
                  placeholder="Search "
                  // onChange={(e) => setSearchUserName(e.target.value)}
                  value={searchUserName}
                />
                <span className="icon-search search-job"></span>
              </div>
              {/* <div className="form-group-2 form-style-1">
                <span className="icon-map-pin"></span>
                <SelectLocation />
              </div>
              <div className="form-group-3 form-style-1">
                <Dropdown
                  options={options1}
                  className="react-dropdown select-location"
                  value={options1[0]}
                />
              </div>
              <div className="form-group-4 form-style-1">
                <Dropdown
                  options={options2}
                  className="react-dropdown select-location"
                  value={options2[0]}
                />
              </div>
              <div className="form-group-5 form-style-1">
                <Dropdown
                  options={options3}
                  className="react-dropdown select-location"
                  value={options3[0]}
                />
              </div> */}
              <div className="form-group-6">
                <button type="submit" className="btn khojPrimaryBtn" style={{ width:'191px', height:'50px'}}>
                  Find Candidates
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

Form2.propTypes = {
  // getCompanyList: PropTypes.func.isRequired,
  // setSearchUserName: PropTypes.func.isRequired,
  // searchUserName: PropTypes.string.isRequired,
};

export default Form2;


// import React, { useState } from "react";
// import PropTypes from "prop-types";
// import SelectLocation from "../dropdown";
// import Dropdown from "react-dropdown";

// const options1 = [
//   { value: "op1", label: "Job Title" },
//   { value: "op2", label: "Design & Creative" },
//   { value: "op3", label: "Design" },
//   { value: "op4", label: "Ux/Ui" },
// ];

// const options2 = [
//   { value: "op1", label: "Any Distance" },
//   { value: "op2", label: "Any Distance 1" },
//   { value: "op3", label: "Any Distance 2" },
// ];
// const options3 = [
//   { value: "op1", label: "Company Size" },
//   { value: "op2", label: "Company Size 1" },
//   { value: "op3", label: "Company Size 2" },
// ];

// Form2.propTypes = {};

// function Form2({props , getCompanyList , setSearchUserName , searchUserName }) {



//   return (
//     <section className="form-sticky stc2">
//       <div className="container">
//         <div className="job-search-form st1 employers-form">
//           <form>
//             <div className="row-group-search inner-form">
//               <div className="form-group-1 form-style-1">
//                 {/* <input
//                   type="text"
//                   className="input-filter-search"
//                   placeholder="key words"
//                 /> */}
// 				<input
//                   type="email"
//                   className="form-control p-2"
//                   id="exampleInputEmail1"
//                   aria-describedby="emailHelp"
//                   placeholder="Search Employers"
//                   onChange={(e) => {
//                     setSearchUserName(e.target.value);
//                     getCompanyList();
//                   }}
//                   value={searchUserName}
//                 />
//                 <span className="icon-search search-job"></span>
//               </div>
//               <div className="form-group-2 form-style-1">
//                 <span className="icon-map-pin"></span>
//                 <SelectLocation />
//               </div>
//               <div className="form-group-3 form-style-1">
//                 <Dropdown
//                   options={options1}
//                   className="react-dropdown select-location"
//                   value={options1[0]}
//                 />
//               </div>
//               <div className="form-group-4 form-style-1">
//                 <Dropdown
//                   options={options2}
//                   className="react-dropdown select-location"
//                   value={options2[0]}
//                 />
//               </div>
//               <div className="form-group-5 form-style-1">
//                 <Dropdown
//                   options={options3}
//                   className="react-dropdown select-location"
//                   value={options3[0]}
//                 />
//               </div>
//               <div className="form-group-6">
//                 <button className="btn btn-find">Find Employers</button>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default Form2;
